// Copyright (c) 2025 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import { ItemTriage, itemTriageSchema } from '@/items/api/triage-types';

/**
 * Type definition for the API response wrapper.
 */
interface ApiResponse {
  data: unknown;
  metadata: { requestId: string };
}

/**
 * Dismisses a triage item, removing it from the pending review queue.
 *
 * @param triageKey - The unique key of the triage item to dismiss
 * @returns Promise containing the updated triage item
 */
export async function dismissTriageItem(
  triageKey: string
): Promise<ItemTriage> {
  const url = `/v1/item-triage/${triageKey}/dismiss`;
  const response = await api.post<ApiResponse>(url);

  // Parse and validate the response with Zod
  return parseResponse(itemTriageSchema, response.data.data, {
    schemaName: 'DismissTriageItem',
    endpoint: url,
  });
}
